module.exports = "/assets/f011490d6dec6552d476349f9620c0b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/GF.png
// module id = 2528
// module chunks = 0